import React from 'react';
import { JobItem } from '../../types';
import { JobsRow } from '../JobsRow';
import './JobsRowList.scss';

export interface JobsRowListProps {
  label: string;
  list: JobItem[];
  onViewReport: () => void;
  onDropdownChange: (option: string) => void;
}

export const JobsRowList: React.FC<JobsRowListProps> = ({
  list,
  label,
  onDropdownChange,
  onViewReport,
}) => (
  <div className="jobs-row-list">
    <div className="jobs-row-list__label">
      {label}
      <span className="jobs-row-list__count">{list.length}</span>
    </div>

    <div className="jobs-row-list__list">
      {list.map((jobsItem) => (
        <JobsRow
          jobItem={jobsItem}
          onDropdownChange={onDropdownChange}
          onViewReport={onViewReport}
        />
      ))}
    </div>
  </div>
);
